<template>
  <CRow>
    <CCol :col="sizeColumns">
      <canvas :id="idCanva" :key="idCanva"></canvas>
    </CCol>
    <CCol :col="sizeColumns">
      <ul class="li-no-bullet mt-4">
        <li v-for="(item, index) in dataLabels" :key="index">
          <i class="bi bi-square-fill mr-2" :style="'color:' + item.color"></i>
          <small>{{ item.label }}</small>
        </li>
      </ul>
    </CCol>

    <CElementCover v-show="loading"/>
  </CRow>
</template>

<script>
  import { ref } from "vue";
    import { uuid } from "vue-uuid"
    import { Chart, registerables } from "chart.js"
    import ChartDataLabels from "chartjs-plugin-datalabels"
    import { formatter } from '../../general'
    import CONSTANTS from '../../constants'
    import { dataCarteraEdades } from '../../apiData'
  
    Chart.register(...registerables)
  
    export default {
      name: 'PortfolioParticipationChart',
      data() {
        return {
          formatter,
          loading: false,
          dataLabels: [],
          dataValues: [],
          semanticDataLabels: {
            "A": {
              label: "Corriente",
              color: CONSTANTS.colors.color01
            },
            "B": {
              label: '1 - 30 Días',
              color: CONSTANTS.colors.color02
            },
            "C": {
              label: '31 - 60 Días',
              color: CONSTANTS.colors.color03
            },
            "D": {
              label: '61 - 90 Días',
              color: CONSTANTS.colors.color04
            },
            "E": {
              label: '91 - 180 Días',
              color: CONSTANTS.colors.color05
            },
            "F": {
              label: '181 - 360 Días',
              color: CONSTANTS.colors.color06
            },
            "G": {
              label: '> 360 Días',
              color: CONSTANTS.colors.color07
            }            
          }
        }
      },
      props: {
        sizeColumns: Number,
        title: String,
        reportType: String,
        portfolioDays: Number,
        idStaffGroup: String,
        idEmployee: String,
        idDirectory: String,
        typeMoney: String,
        dollarValue: Number
      },
      methods: {
        async getPortfolioParticipation(){
          try {
            const { response } = await dataCarteraEdades(
              this,
              this.reportType,
              this.portfolioDays,
              this.idStaffGroup,
              this.idEmployee,
              this.idDirectory
            )

            this.dataLabels = response.map(element => this.semanticDataLabels[element['Dias_Cartera']])
            this.dataValues = response.map(element => element['ValorCartera'])
          } catch (error) {
            console.log(error)
          }
        },
        setupChart(){
          const opciones = {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: this.title
              },
              legend: {
                display: true,
                position: "left",
                // align: "start",
                labels: {
                  boxWidth: 10,
                  boxHeight: 10,
                  font: {
                    size: 10
                  }
                }
              },
              tooltip: {
                enabled: true
              },
              datalabels: {
                font: {
                  size: 10
                },
                formatter: (value) => {
                  let sum = 0;
                  this.dataValues.map(data => sum += data);
                  let porcentaje = ((value * 100) / sum).toFixed(2);
                  if (porcentaje < 5) return "";

                  return porcentaje + "%";
                }
              }
            }
          }

          const chart = new Chart(
            document.getElementById(this.idCanva),
            {
              type: "pie",
              data: {
                labels: this.dataLabels.map(() => ""),
                datasets: [
                  {
                    data: this.dataValues,
                    backgroundColor: this.dataLabels.map(val => val.color),
                    hoverOffset: 5
                  }
                ],
              },
              options: opciones,
              plugins: [ChartDataLabels]
            }
          )
  
          chart.update()
        }
      },
      setup() {
        const idCanva = ref("");
        idCanva.value = uuid.v4();
        
        return {
          idCanva
        }
      },
      async mounted(){
        this.loading = true

        await this.getPortfolioParticipation()
        this.setupChart()

        this.loading = false
      }
    }
</script>
